import React, { useEffect, useState} from 'react';
import isMobile from 'common/helpers/isMobile';
import classNames from 'classnames';
import { t } from 'translates';

function ToggleButton(props) {
  const [isActive, setIsActive] = useState(props.filterCurrent !== null ? (props.filterCurrent === "true") : props.defaultValue);

  useEffect(() => {
    setIsActive(props.filterCurrent !== null ? (props.filterCurrent === "true") : props.defaultValue);
  }, [props.filterOpen]);

  const toggle = (value) => {
    setIsActive(!isActive);
    props.change(props.name, +value, props.label);
  };

  return (
    <button
      className={classNames('sessions-new-filter__toggle-btn',
        {
          'is-active': isActive,
          'sessions-new-filter__toggle-btn--mobile': isMobile,
          'sessions-new-filter__toggle-btn--radio': props.type === 'radio'
        }
      )}
      onClick={() => {toggle(!isActive);}}>
      {t(props.label, DT_SESSIONSNEW)}
    </button>
  );
}

export default  ToggleButton;
